import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import moment from "moment";
import { ActivatedRoute } from "@angular/router";
import { ValidationService } from "src/app/services/validation.service";
import { clearConfig } from "dompurify";
import * as Constants from "../../../../constant/Constants";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { MatDialog } from "@angular/material/dialog";
import { ApiCallService } from "src/app/api/service/api-call.service";
import { environment } from "src/environments/environment";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { CurrencyPipe } from "@angular/common";
import { Router } from '@angular/router';

@Component({
  selector: "app-page-three",
  templateUrl: "./claim-details.component.html",
  styleUrls: ["./claim-details.component.css"],
})
export class ClaimDetailsComponent implements OnInit {
  // Url Params
  claim: string = "windscreen"; // windscreen, entertainemt, own, theft, fire, flood ... etc.
  type: string = "rep"; // windscreen, Ent :[rep, no-rep], theft: [total, partial] ... etc.
  id: string = "none";
  replaced: string = 'false';
  token: string = "placeholder-value"; // to validate the public accesses.

  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  AntiTheftPlaceHolders: any = ["Simple", "Alarm", "Robocop"];

  pageHeading: string = "Claim Form";
  pageHeadingSuffix: string = " Claim Form";

  driverDetailsHeading: string = "Enter Driver Details";
  thiefSubheading: string = "Please enter details below";

  driverQuestion: string = "Who was driving the vehicle?";

  ownerLabel: string = "Owner";
  someoneLabel: string = "Someone else";
  fullNameLabel: string = "Full Name";
  fullNameAltLabel: string = "Your Full Name";

  addressLabel: string = "Address";
  driverNameHint: string = "The driver's name";
  driverIDHint: string = "The driver's ID number";
  otherDriverAdHint: string = "The driver's address";
  driverPhoneHint: string = "The driver's Tel number";
  licenceLabel: string = "License Number";
  otherDriverLiceHint: string = "The driver's license number";
  dateIssueLabel: string = "Date of issue";

  idNumLabel: string = "ID Number";
  kraNumLabel: string = "KRA PIN Number (optional)";
  telLabel: string = "Telephone Number";
  dobLabel: string = "Date of birth";

  additionalInfoHeading: string = "Additional Info";
  driverRelationshipLabel: string = "Relationship with driver";
  serviceQuestion: string = "Has the driver ever been in your service?";
  driverYearsQuestion: string =
    "How long has the driver been driving a motor vehicle?";
  serviceYearsLabel: string = "Enter number of years under your service";
  numOfYearsLabel: string = "Enter number of years";
  blameGameQuestion: string =
    "Was the driver in any way to blame for the accident?";
  admitLiabilityQuestion: string = "Did the driver admit liability?";
  previousAccQuestion: string = "Has the driver had any previous accidents?";
  numOfAccidentsLabel: string = "Number of accidents";
  dateAccidentLabel: string = "Date of accident";
  convictionQuestion: string =
    "Has the driver had any conviction for any offence in connection with any motor vehicle or any changes pending?";
  convictionDetailsLabel: string = "Please give details of the convictions";
  dateConvictionLabel: string = "Date of conviction";
  licenceTypeQuestion: string =
    "Does the driver hold a full or provisional license to drive the vehicle?";
  fullText: string = "Full";
  provisionalText: string = "Provisional";
  dateFirstDrivingLabel: string = "Date of first driving date passed";
  ownMotorVehicleQuestion: string = "Does he own a motor vehicle?";
  insurerNameLabel: string = "Enter name of insurer";
  insurerAddressLabel: string = "Enter address of insurer";

  authorityQuestion: string = "Was He/She Driving With Your Authority?";

  yesText: string = "Yes";
  noText: string = "No";

  secondSubHeading: string = "Details of Loss";
  accidentDateLabel: string = "Date of loss";
  accidentTimeLabel: string = "Time of loss";
  accidentLocationLabel: string = "Location of loss";

  purposeQuestionLabel: string =
    "What purpose was the vehicle being used for at time of occurrence?";
  damageInfoLabel: string =
    "Please give full information as to how the damage occurred";

  locationLossLabel: string = "";
  personInChargeLabel: string = "Person in-charge of vehicle";
  personInChargeSubtext: string =
    "The person in charge of the vehicle at the time of loss";
  securelyLockedQuestion: string =
    "Were all doors in the vehicle securely locked?";
  windowsClosedQuestion: string = "Were all windows closed?";
  antiTheftDeviceQuestion: string = "Was an anti-theft device fitted?";
  selectAntitheftLabel: string = "Select anti-theft type";
  selectAntitheftTextLabel: string =
    "Select the anti-theft devices that were fitted";

  lossInfoLabel: string =
    "Please give full information as to how the loss occurred";

  particularsLossSubheading: string = "Particulars of Loss";

  stolenQuestion: string =
    "Was the entertainment unit/radio stolen or damaged?";
  altStolenQuestion: string = "";

  replacementValueLabel: string = "Replacement value";
  replacementValueSubtext: string = "The replacement value of the stolen radio";
  anyOtherDamageQuestion: string =
    "Was there damage to any other part of the vehicle?";
  damageDetailsText: string = "Please give details of the damage";

  soleOwnerQuestion: string = "Are you the sole owner of the vehicle?";
  previousOwnerLabel: string = "Previous owner of vehicle";
  purchaseDateLabel: string = "Date of purchase";

  hpInterestQuestion: string = "Is there any hire purchase interest?";
  hpInterestLabel: string = "Please give details of the hire purchase";

  trackingDeviceText: string = "Tracking device";
  carAlarmText: string = "Car alarm";
  cutOffText: string = "Cut-off";
  gearLockText: string = "Gear-lock";

  stolenText: string = "Stolen";
  damagedText: string = "Damaged";

  cancelText: string = "Cancel";
  saveText: string = "Save and Continue";

  dateLabel: string = "Date";

  minDate: Date;
  maxDate: Date;

  minLossDate: Date;

  minIssueDate: Date;
  maxIssueDate: Date;

  minDobDate: Date;
  maxDobDate: Date;

  ownerDriving: boolean = true;
  driverAuthorized: boolean = true;

  requiredString: string = 'This field is required';
  selectOptionString: string = 'Please select one option to continue';
  selectAtLeastString: string = 'Please select at least one option from above';
  iSwearText: string = 'I hereby declare that these particulars are true, and undertake to forward immediately (if any, unanswered), correspondence relating to this accident.';

  namePlaceHolder: string = '';

  motorForm = this._formBuilder.group({
    fullName: ["", Validators.required],
    address: [""],
    // licenseNumber: [""],
    dateIssue: [moment(null)],

    idNum: [""],
    kraPin: ["", Validators.pattern(/^[AP]\d{9}[A-Z]$/)],
    tel: [""],
    dob: [""],

    // Aditional info
    driverRelationship: [""],
    driverInService: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    driverServiceYears: [""],
    driverYears: [""],

    previousAccident: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    driverBlame: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    driverAdmitLiability: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    driverConvicted: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    driverLicense: this._formBuilder.group({
      full: true,
      provisional: false,
    }),

    driverHasMotor: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    accidentNumber: [""],
    dateAccident: [moment(null)],

    convictionsDetails: [""],
    dateConviction: [""],
    datePassDriving: [""],
    insurerName: [""],
    insurerAddress: [""],

    eventDate: [moment(null)],
    eventTime: [""],
    location: [""],

    lossExplanation: ["", Validators.required],
    purposeExplanation: ["", Validators.required],
    damageExplanation: ["", Validators.required],

    personInCharge: ["", Validators.required],
    antiTheftType: [""],

    replacementValue: [""],
    damageDetails: [""],

    ownerName: ["", [Validators.required, Validators.pattern(/^.+ .+/)]],
    date: [moment(), Validators.required],
    driver: this._formBuilder.group({
      isOwner: true,
      isElseOne: false,
    }),

    drivingDuringTheft: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    driverAuthorized: this._formBuilder.group({
      yes: true,
      no: false,
    }),

    doorsLocked: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    windowsClosed: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    antiTheftFitted: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    stolenOrDamaged: this._formBuilder.group({
      stolen: false,
      damaged: true,
    }),

    extraDamage: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    extraDamageText: ["", Validators.required],

    soleOwner: this._formBuilder.group({
      yes: true,
      no: false,
    }),

    hpInterest: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    antiTheft: this._formBuilder.group({
      trackingDevice: false,
      carAlarm: false,
      cutOff: false,
      gearLock: false,
    }),

    previousOwner: ["", Validators.required],
    purchaseDate: ["", Validators.required],
    hpDetails: ["", Validators.required],
    iSwear: [false],
  });
  formGroupErrors: { [key: string]: string } = {
    driver: "",
    driverAuthorized: "",
    drivingDuringTheft: "",
    stolenOrDamaged: "",
    soleOwner: "",
    hpInterest: "",
    antiTheft: "",
    extraDamage: "",
    extraDamageText: "",
    driverInService: "",
    driverServiceYears: "",
    driverBlame: "",
    driverAdmitLiability: "",
    previousAccident: "",
    driverConvicted: "",
    driverLicense: "",
    driverHasMotor: "",
  };
  formErrors: { [key: string]: string } = {
    fullName: "",
    address: "",
    // licenseNumber: "",
    dateIssue: "",
    idNum: "",
    kraPin: "",
    tel: "",
    dob: "",
    driverRelationship: "",
    driverYears: "",
    accidentNumber: "",
    dateAccident: "",
    convictionsDetails: "",
    dateConviction: "",
    datePassDriving: "",
    insurerName: "",
    insurerAddress: "",
    eventDate: "",
    eventTime: "",
    location: "",
    lossExplanation: "",
    purposeExplanation: "",
    damageExplanation: "",
    personInCharge: "",
    antiTheftType: "",
    replacementValue: "",
    damageDetails: "",
    date: "",
    ownerName: "",
    doorsLocked: "",
    windowsClosed: "",
    antiTheftFitted: "",
    previousOwner: "",
    purchaseDate: "",
    hpDetails: "",
    iSwear: "",
  };
  validationMessages: { [key: string]: { [key: string]: string } } = {
    fullName: { required: this.requiredString },
    address: { required: this.requiredString  },
    // licenseNumber: { required: this.requiredString  },
    dateIssue: { required: this.requiredString  },
    idNum: { required: this.requiredString, minlength: 'Invalid number', maxlength: 'Invalid number'},
    kraPin: { pattern: 'Invalid KRA PIN' },
    tel: { required: this.requiredString  },
    dob: { required: this.requiredString  },
    driverRelationship: { required: this.requiredString  },
    // driverYears: { required: this.requiredString  },
    driverInService: { required: this.requiredString  },
    driverServiceYears: { required: this.requiredString  },
    previousAccident: { required: this.requiredString  },
    driverBlame: { required: this.requiredString  },
    driverAdmitLiability: {required: this.requiredString },
    driverConvicted: { required: this.requiredString  },
    driverLicense: { required: this.requiredString  },
    driverHasMotor: { required: this.requiredString },
    accidentNumber: { required: this.requiredString  },
    dateAccident: { required: this.requiredString },
    convictionsDetails: { required: this.requiredString  },
    dateConviction: { required: this.requiredString  },
    // datePassDriving: { required: this.requiredString  },
    insurerName: { required: this.requiredString  },
    insurerAddress: { required: this.requiredString  },
    eventDate: { required: this.requiredString  },
    eventTime: { required: this.requiredString  },
    location: { required: this.requiredString  },
    lossExplanation: {requird: this.requiredString},
    purposeExplanation: { required: this.requiredString  },
    damageExplanation: { required: this.requiredString },
    personInCharge: { required: this.requiredString },
    antiTheftType: { required: this.selectAtLeastString },
    replacementValue: { required: this.requiredString },
    damageDetails: { required: this.requiredString },
    date: { required: this.requiredString },
    driver: { required: this.requiredString },
    drivingDuringTheft: { required: this.selectOptionString },
    ownerName: { required: this.requiredString },
    driverAuthorized: { required: this.selectOptionString },
    doorsLocked: { required: this.selectOptionString },
    windowsClosed: { required: this.selectOptionString },
    antiTheftFitted: { required: this.selectOptionString },
    stolenOrDamaged: { required: this.selectOptionString },
    extraDamage: { required: this.requiredString },
    extraDamageText: {required: this.requiredString},
    soleOwner: { required: this.selectOptionString },
    hpInterest: { required: this.selectOptionString },
    antiTheft: { required: this.selectAtLeastString },
    previousOwner: { required: this.requiredString },
    purchaseDate: { required: this.requiredString },
    hpDetails: { required: this.requiredString },
  };

  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private validationService: ValidationService,
    private apiCallService: ApiCallService,
    private currencyPipe: CurrencyPipe,
    public dialog: MatDialog
  ) {
    const currentDate = new Date();
    const tempDate = new Date(currentDate.getTime());
    const tempDate2 = new Date(currentDate.getTime());
    const tempDate3 = new Date(currentDate.getTime());
    
    const maxDob = new Date(currentDate.getTime());
    const minDob = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 10);
    tempDate2.setFullYear(currentDate.getFullYear() - 75);
    tempDate3.setFullYear(currentDate.getFullYear() - 1);

    this.minDate = tempDate;
    this.maxDate = currentDate; // Check on this later

    this.minIssueDate = tempDate2;
    this.maxIssueDate = currentDate;

    this.minLossDate = tempDate3;

    minDob.setFullYear(currentDate.getFullYear() - 150);
    maxDob.setFullYear(currentDate.getFullYear() - 18);

    this.minDobDate = minDob;
    this.maxDobDate = maxDob;
  }

  altView: boolean = false;
  additionalInfo: boolean = false;
  isOwnFireFlood: boolean = false;

  loading: boolean = false;
  url: string = environment.baseUrl + Constants.claimDetailsURL;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;

      if (params['replaced'] !== undefined) {
        this.replaced = params['replaced'];
      }
      if (params["id"] !== undefined) {
        this.id = params["id"];

        this.getPolicyDetails();
      }

      if (params["claim"] !== undefined) {
        this.claim = params["claim"];
        const isTheft = params["claim"] === "theft";
        const isWindScreen = params["claim"] === "windscreen";
        const isEntertainment = params["claim"] === "entertainment";
        this.isOwnFireFlood =
          params["claim"] === "own" ||
          params["claim"] === "flood" ||
          params["claim"] === "fire";

        if (!this.isOwnFireFlood) {
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("address")!
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("eventTime")!
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("location")!
          );
          
          
        }
        if (!isTheft) {
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "driver",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
        }
        if (isTheft || this.isOwnFireFlood) {
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("tel")!
          );
          this.validationService.addOrRemoveIDumValidator(true, this.motorForm.get('idNum')!, 8, 9)
        }

        if (isEntertainment || isWindScreen) {
          // this.validationService.addOrRemoveValidator(
          //   true,
          //   this.motorForm.get("licenseNumber")!
          // );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("dateIssue")!
          );
        }
        if (isWindScreen) {
          this.pageHeading = "Windscreen Damage" + this.pageHeadingSuffix;
          this.altView = false;

          this.secondSubHeading = "Accident Details";
          this.accidentDateLabel = "Date of accident";
          this.accidentTimeLabel = "Time of accident";
          this.accidentLocationLabel = "Location of accident";
        } else if (isEntertainment) {
          this.altView = true;
          this.pageHeading =
            "Entertainment/Radio Unit" + this.pageHeadingSuffix;
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("replacementValue")!
          );

          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "doorsLocked",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "windowsClosed",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "antiTheftFitted",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );

        } else if (isTheft) {
          this.altView = true;
          this.driverDetailsHeading = "Enter Details";
          this.driverQuestion =
            "Was anyone driving the vehicle at the time of theft?";
          this.addressLabel = "Postal Address";
          this.authorityQuestion =
            "Was the vehicle in use with the insured's permission or authority?";

          if (params["type"] === "total") {
            this.pageHeading = "Total Loss - Theft" + this.pageHeadingSuffix;
          } else if (params["type"] === "partial") {
            this.pageHeading = "Partial Theft" + this.pageHeadingSuffix;
          }
          // ----- Add validation
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "drivingDuringTheft",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "soleOwner",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "hpInterest",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );

          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "doorsLocked",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "windowsClosed",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidityOnFormGroup(
            true,
            "antiTheftFitted",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );

        } else if (this.isOwnFireFlood) {
          
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("dob")!
          );
          this.additionalInfo = true;
          this.altView = false;
          if (this.claim === 'fire') {
            this.pageHeading = "Fire Damage" + this.pageHeadingSuffix;
          } else if (this.claim === 'flood') {
            this.pageHeading = "Flood Damage" + this.pageHeadingSuffix;
          } else {
            this.pageHeading = "Own Damage/Car Damage" + this.pageHeadingSuffix;
          }
        }
      }

      if (params["type"] !== undefined) {
        this.type = params["type"];

        if (params["type"] !== "rep") {
        }
      }
    });

    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("driver.isElseOne")!,
      "driverAuthorized",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    // this.validationService.addOrRemoveValidationDependent(
    //   this.motorForm.get("antiTheftFitted.yes")!,
    //   "antiTheft",
    //   this.motorForm,
    //   this.formGroupErrors,
    //   this.validationMessages
    // );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("driver.isElseOne")!,
      "driverRelationship",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    // this.validationService.addOrRemoveValidationDependent(
    //   this.motorForm.get("driver.isElseOne")!,
    //   "driverYears",
    //   this.motorForm,
    //   this.formGroupErrors,
    //   this.validationMessages
    // );
    // this.validationService.addOrRemoveValidationDependent(
    //   this.motorForm.get("driver.isElseOne")!,
    //   "datePassDriving",
    //   this.motorForm,
    //   this.formGroupErrors,
    //   this.validationMessages
    // );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("previousAccident.yes")!,
      "accidentNumber",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("previousAccident.yes")!,
      "accidentNumber",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("previousAccident.yes")!,
      "dateAccident",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("driverConvicted.yes")!,
      "convictionsDetails",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("driverConvicted.yes")!,
      "dateConviction",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("driverInService.yes")!,
      "driverServiceYears",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    // this.validationService.addOrRemoveValidationDependent(
    //   this.motorForm.get("driverHasMotor.yes")!,
    //   "insurerName",
    //   this.motorForm,
    //   this.formGroupErrors,
    //   this.validationMessages
    // );
    // this.validationService.addOrRemoveValidationDependent(
    //   this.motorForm.get("driverHasMotor.yes")!,
    //   "insurerAddress",
    //   this.motorForm,
    //   this.formGroupErrors,
    //   this.validationMessages
    // );
    this.validationService.subcribeToControlChanges(
      "driver",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "driverAuthorized",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "drivingDuringTheft",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "doorsLocked",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "windowsClosed",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "antiTheftFitted",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "stolenOrDamaged",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "soleOwner",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "hpInterest",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "antiTheft",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "extraDamage",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "driverInService",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "driverBlame",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "driverAdmitLiability",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "previousAccident",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "driverConvicted",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "driverLicense",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "driverHasMotor",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );

    this.motorForm.valueChanges.subscribe((form) => {
      this.logErrors();

      if (form.fullName) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          fullName: form.fullName.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.ownerName) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          ownerName: form.ownerName.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.driverRelationship) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          driverRelationship: form.driverRelationship.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.address) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          address: form.address.replace(/[^\w\s\d]/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      // if (form.licenseNumber) {
      //   this.motorForm.patchValue({
      //     // First replace: remove strings, 2nd replace: leading zeros
      //     licenseNumber: form.licenseNumber.replace(/[^\w\d]/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
      //   }, {emitEvent: false});
      // }
      if (form.location) {
        this.motorForm.patchValue({
          location: form.location.replace(/[^\w\s\d]/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.personInCharge) {
        this.motorForm.patchValue({
          personInCharge: form.personInCharge.replace(/[^\w\s]/g, '').replace(/\d/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.replacementValue) {
        this.motorForm.patchValue({
          replacementValue: this.currencyPipe.transform(form.replacementValue.replace(/\D/g, '').replace(/^0+/, ''), 'KES  ', 'symbol', '1.0-0')
        }, {emitEvent: false});
      }
      if (form.idNum) {
        this.motorForm.patchValue({
          idNum: form.idNum.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (form.kraPin) {
        this.motorForm.patchValue({
          kraPin: form.kraPin.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.tel) {
        this.motorForm.patchValue({
          tel: form.tel.replace(/\D/g, '')
        }, {emitEvent: false});
      }

      if (form.driverYears) {
        this.motorForm.patchValue({
          driverYears: form.driverYears.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (this.altView === true) {
        this.motorForm.controls['damageExplanation'].setErrors(null);
      }
      if (this.motorForm.controls['extraDamage'].controls['yes'].value !== true) {
        this.motorForm.controls['extraDamageText'].setErrors(null);
      }
      if (this.additionalInfo === true) {
        this.motorForm.controls['purposeExplanation'].setErrors(null);
        this.motorForm.controls['damageExplanation'].setErrors(null);
      }
      if (this.claim === 'theft') {
        this.motorForm.controls['purposeExplanation'].setErrors(null);
      }
      if (!(this.additionalInfo === false && this.altView === true)) {
        this.motorForm.controls['lossExplanation'].setErrors(null);
        this.motorForm.controls['personInCharge'].setErrors(null);
      }
      // if (!this.isOwnFireFlood) {
      //   this.motorForm.controls['kraPin'].setErrors(null);
      // }
      if (!(this.additionalInfo === false && this.claim === 'entertainment' && this.type === 'no-rep')) {
        this.motorForm.controls['ownerName'].setErrors(null);
      }

      if (this.motorForm.controls["soleOwner"].controls['yes'].value === true
          && this.motorForm.controls["hpInterest"].controls['no'].value === true) {
        this.motorForm.controls["previousOwner"].setErrors(null);
        this.motorForm.controls["purchaseDate"].setErrors(null);
        this.motorForm.controls["hpDetails"].setErrors(null);
      }
    });
  }

  async getPolicyDetails() {
    try {
      const dat = {
        id: this.id
      };
      const response = await this.apiCallService.postRequest(
        environment.baseUrl + Constants.policyDetailsURL, dat);

      if (response.error) {
        console.log(':Get details ERROR :: ', response);
      } else {
        this.namePlaceHolder = response.body.name;
        this.motorForm.get('fullName')?.setValue(this.namePlaceHolder);
        this.motorForm.get('ownerName')?.setValue(this.namePlaceHolder);
      }
    } catch (error) {
      console.log(':Details ERROR !! :: ', error);
    }
  }

  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  onOwnerChange() {
    this.motorForm.controls["driver"].controls["isElseOne"].setValue(false);
    this.motorForm.get('driverAuthorized')?.setErrors(null);
    this.motorForm.get('driverAuthorized')?.markAsUntouched();

    if (!this.motorForm.get('fullName')?.dirty) {
      this.motorForm.get('fullName')?.setValue(this.namePlaceHolder);
    }
  }

  onElseOneChange() {
    this.motorForm.controls["driver"].controls["isOwner"].setValue(false);
    this.motorForm.get('driverAuthorized')?.markAsTouched();

    if (!this.motorForm.get('fullName')?.dirty) {
      this.motorForm.get('fullName')?.setValue('');
    }
  }

  onTheftYesDrivingChange() {
    this.motorForm.controls["drivingDuringTheft"].controls["no"].setValue(
      false
    );
  }

  onTheftNoDrivingChange() {
    this.motorForm.controls["drivingDuringTheft"].controls["yes"].setValue(
      false
    );
  }

  onYesChange() {
    this.motorForm.controls["driverAuthorized"].controls["no"].setValue(false);
  }

  onNoChange() {
    this.motorForm.controls["driverAuthorized"].controls["yes"].setValue(false);
  }

  onYes2Change() {
    this.motorForm.controls["doorsLocked"].controls["no"].setValue(false);
  }

  onNo2Change() {
    this.motorForm.controls["doorsLocked"].controls["yes"].setValue(false);
  }

  onYes3Change() {
    this.motorForm.controls["windowsClosed"].controls["no"].setValue(false);
  }

  onNo3Change() {
    this.motorForm.controls["windowsClosed"].controls["yes"].setValue(false);
  }

  onYes4Change() {
    this.motorForm.controls["antiTheftFitted"].controls["no"].setValue(false);
  }

  onNo4Change() {
    this.motorForm.controls["antiTheftFitted"].controls["yes"].setValue(false);
  }

  onYes5Change() {
    this.motorForm.controls["extraDamage"].controls["no"].setValue(false);
  }

  onNo5Change() {
    this.motorForm.controls["extraDamage"].controls["yes"].setValue(false);
  }

  onYes6Change() {
    this.motorForm.controls["driverInService"].controls["no"].setValue(false);
  }

  onNo6Change() {
    this.motorForm.controls["driverInService"].controls["yes"].setValue(false);
  }

  onYes7Change() {
    this.motorForm.controls["previousAccident"].controls["no"].setValue(false);
  }

  onNo7Change() {
    this.motorForm.controls["previousAccident"].controls["yes"].setValue(false);
  }

  onYes8Change() {
    this.motorForm.controls["driverBlame"].controls["no"].setValue(false);
  }

  onNo8Change() {
    this.motorForm.controls["driverBlame"].controls["yes"].setValue(false);
  }

  onYes9Change() {
    this.motorForm.controls["driverAdmitLiability"].controls["no"].setValue(
      false
    );
  }

  onNo9Change() {
    this.motorForm.controls["driverAdmitLiability"].controls["yes"].setValue(
      false
    );
  }

  onYes10Change() {
    this.motorForm.controls["driverConvicted"].controls["no"].setValue(false);
  }

  onNo10Change() {
    this.motorForm.controls["driverConvicted"].controls["yes"].setValue(false);
  }

  onYes11Change() {
    this.motorForm.controls["driverHasMotor"].controls["no"].setValue(false);
  }

  onNo11Change() {
    this.motorForm.controls["driverHasMotor"].controls["yes"].setValue(false);
  }

  onYes12Change() {
    this.motorForm.controls["soleOwner"].controls["no"].setValue(false);
    this.motorForm.controls["previousOwner"].setErrors(null);
    this.motorForm.controls["purchaseDate"].setErrors(null);
  }

  onNo12Change() {
    this.motorForm.controls["soleOwner"].controls["yes"].setValue(false);
  }

  onYes13Change() {
    this.motorForm.controls["hpInterest"].controls["no"].setValue(false);
  }

  onNo13Change() {
    this.motorForm.controls["hpInterest"].controls["yes"].setValue(false);
    this.motorForm.controls["hpDetails"].setErrors(null);
  }

  onFullLicenseChange() {
    this.motorForm.controls["driverLicense"].controls["provisional"].setValue(
      false
    );
  }

  onProvLicenceChange() {
    this.motorForm.controls["driverLicense"].controls["full"].setValue(false);
  }

  onStolenChange() {
    this.motorForm.controls["stolenOrDamaged"].controls["damaged"].setValue(
      false
    );
  }

  onDamagedChange() {
    this.motorForm.controls["stolenOrDamaged"].controls["stolen"].setValue(
      false
    );
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };
  
  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      isDriver: this.motorForm.controls["driver"].controls['isOwner'].value === true ||
        this.motorForm.controls["drivingDuringTheft"].controls["yes"].value === true ? 'Yes' : 'No',
      fullName: this.motorForm.controls["fullName"].value,
      address: this.motorForm.controls["address"].touched ? this.motorForm.controls["address"].value : null,
      // license: this.motorForm.controls["licenseNumber"].touched ? this.motorForm.controls["licenseNumber"].value : null,
      licenceDate: this.motorForm.controls["dateIssue"].touched ? this.motorForm.controls["dateIssue"].value : null,

      idNo: this.motorForm.controls["idNum"].touched ? this.motorForm.controls["idNum"].value : null,
      kraPin: this.motorForm.controls["kraPin"].touched ? this.motorForm.controls["kraPin"].value : null,
      phone: this.motorForm.controls["tel"].touched ? this.motorForm.controls["tel"].value : null,
      dob: this.motorForm.controls["dob"].touched ? this.motorForm.controls["dob"].value : null,

      driverRelationship: this.motorForm.controls["driverRelationship"].touched ? this.motorForm.controls["driverRelationship"].value : null,
      driverInService: !(this.additionalInfo === true && this.motorForm.controls['driver'].controls['isElseOne'].value === true) ? null : this.motorForm.controls["driverInService"].controls["yes"].value === true ? 'Yes' : 'No',
      driverServiceYears: this.motorForm.controls["driverInService"].controls["yes"].value === true ? this.motorForm.controls["driverServiceYears"].value : null,
      driverYears:  this.motorForm.controls["driverYears"].touched ? this.motorForm.controls["driverYears"].value : null,

      previousAccident:  !(this.additionalInfo === true && this.motorForm.controls['driver'].controls['isElseOne'].value === true) ? null : this.motorForm.controls["previousAccident"].controls["yes"].value === true ? 'Yes' : 'No',
      driverBlame:  !(this.additionalInfo === true && this.motorForm.controls['driver'].controls['isElseOne'].value === true) ? null : this.motorForm.controls["driverBlame"].controls["yes"].value === true ? 'Yes' : 'No',
      driverAdmitLiability:  !(this.additionalInfo === true && this.motorForm.controls['driver'].controls['isElseOne'].value === true) ? null : this.motorForm.controls["driverAdmitLiability"].controls["yes"].value === true ? 'Yes' : 'No',
      driverConvicted:  !(this.additionalInfo === true && this.motorForm.controls['driver'].controls['isElseOne'].value === true) ? null : this.motorForm.controls["driverConvicted"].controls["yes"].value === true ? 'Yes' : 'No',
      driverLicenseType:  !(this.additionalInfo === true && this.motorForm.controls['driver'].controls['isElseOne'].value === true) ? null : this.motorForm.controls["driverLicense"].controls["full"].value === true ? 'Full' : 'Provisional',
      driverHasVehicle:  !(this.additionalInfo === true && this.motorForm.controls['driver'].controls['isElseOne'].value === true) ? null : this.motorForm.controls["driverHasMotor"].controls["yes"].value === true ? 'Yes' : 'No',

      accidentNumber: this.motorForm.controls["accidentNumber"].untouched ? null : this.motorForm.controls["accidentNumber"].value,
      accidentDate: this.motorForm.controls["dateAccident"].untouched ? null : this.motorForm.controls["dateAccident"].value,
      convictionsDetails: this.motorForm.controls["convictionsDetails"].untouched ? null : this.motorForm.controls["convictionsDetails"].value,
      dateConviction: this.motorForm.controls["dateConviction"].untouched ? null : this.motorForm.controls["dateConviction"].value,
      datePassDriving: this.motorForm.controls["datePassDriving"].untouched ? null : this.motorForm.controls["datePassDriving"].value,
      insurerName: this.motorForm.controls["insurerName"].untouched ? null : this.motorForm.controls["insurerName"].value,
      insurerAddress: this.motorForm.controls["insurerAddress"].untouched ? null : this.motorForm.controls["insurerAddress"].value,
      eventDate: this.motorForm.controls["eventDate"].untouched ? null : this.motorForm.controls["eventDate"].value,
      eventTime: this.motorForm.controls["eventTime"].untouched ? null : this.motorForm.controls["eventTime"].value,
      location: this.motorForm.controls["location"].untouched ? null : this.motorForm.controls["location"].value,
      lossExplanation: this.motorForm.controls["lossExplanation"].untouched ? null : this.motorForm.controls["lossExplanation"].value,
      purposeExplanation: this.motorForm.controls["purposeExplanation"].untouched ? null : this.motorForm.controls["purposeExplanation"].value,
      damageExplanation: this.motorForm.controls["damageExplanation"].untouched ? null : this.motorForm.controls["damageExplanation"].value,
      personInCharge: this.motorForm.controls["personInCharge"].untouched ? null : this.motorForm.controls["personInCharge"].value,
      antiTheftType: this.motorForm.controls["antiTheftType"].untouched ? null : this.motorForm.controls["antiTheftType"].value,
      replacementValue: this.motorForm.controls["replacementValue"].untouched ? null : this.motorForm.controls["replacementValue"].value?.replace(/\D/g,''),
      damageDetails: this.motorForm.controls["damageDetails"].untouched ? null : this.motorForm.controls["damageDetails"].value,

      ownerName: !(this.additionalInfo === false && this.claim === 'entertainment' && this.type === 'no-rep') ? null : this.motorForm.controls["ownerName"].value,
      reportDate: !(this.additionalInfo === false && this.claim === 'entertainment' && this.type === 'no-rep') ? null : this.motorForm.controls["date"].value,
    
      driverAuthorized: this.motorForm.controls["driver"].controls['isOwner'].value === true || this.motorForm.controls["drivingDuringTheft"].controls["yes"].value === true ? null : this.motorForm.controls["driverAuthorized"].controls["yes"].value === true ? 'Yes' : 'No',
      doorsLocked: !this.altView ? null : this.motorForm.controls["doorsLocked"].controls["yes"].value === true ? 'Yes' : 'No',
      windowsClosed: !this.altView ? null : this.motorForm.controls["windowsClosed"].controls["yes"].value === true ? 'Yes' : 'No',
      antiTheftFitted: !this.altView ? null : this.motorForm.controls["antiTheftFitted"].controls["yes"].value === true ? 'Yes' : 'No',

      stolenOrDamaged: this.claim === 'entertainment' ? (this.motorForm.controls["stolenOrDamaged"].controls["stolen"].value === true ? 'Stolen' : 'Damaged') : null,

      extraDamage: !(this.additionalInfo === false && this.altView === true) ? null : this.motorForm.controls["extraDamage"].controls["yes"].value === true ? 'Yes' : 'No',
      extraDamageText: this.motorForm.controls["extraDamage"].controls["yes"].value !== true ? null : this.motorForm.controls["extraDamageText"].value,
      soleOwner: this.claim === 'theft' ? (this.motorForm.controls["soleOwner"].controls["yes"].value === true ? 'Yes' : 'No') : null,
      hpInterest: this.claim === 'theft' ? (this.motorForm.controls["hpInterest"].controls["yes"].value === true ? 'Yes' : 'No') : null,

      trackingDevice: this.motorForm.controls["antiTheftFitted"].controls['yes'].value !== true ? null : this.motorForm.controls["antiTheft"].controls["trackingDevice"].value === true ? 'Yes' : 'No',
      carAlarm: this.motorForm.controls["antiTheftFitted"].controls['yes'].value !== true ? null : this.motorForm.controls["antiTheft"].controls["carAlarm"].value === true ? 'Yes' : 'No',
      cutOff: this.motorForm.controls["antiTheftFitted"].controls['yes'].value !== true ? null : this.motorForm.controls["antiTheft"].controls["cutOff"].value === true ? 'Yes' : 'No',
      gearLock: this.motorForm.controls["antiTheftFitted"].controls['yes'].value !== true ? null : this.motorForm.controls["antiTheft"].controls["gearLock"].value === true ? 'Yes' : 'No',
      
      previousOwner: this.motorForm.controls["soleOwner"].controls["no"].value === true ? null : this.motorForm.controls["previousOwner"].value,
      purchaseDate: this.motorForm.controls["soleOwner"].controls["no"].value === true ? null : this.motorForm.controls["purchaseDate"].value,
      hpDetails: this.motorForm.controls["hpInterest"].controls["yes"].value === true ? this.motorForm.controls["hpDetails"].value : null,

      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        // console.log("::: Post successful :::");
        
        if (this.claim === 'theft') {
          // Navigate to Page 2 of Theft claims Form
          const nextToken = response.token;
          const nextPage = `/theft-details`;
          
          this.router.navigate([nextPage],
            {queryParams: {type: this.type, token: nextToken, id: this.id, replaced: this.replaced}});

        } else if (this.claim === 'windscreen' || this.claim === 'entertainment') {
          // Navigate back to Whatsapp chat
          window.location.href = environment.whatsappRedirectURL;
        } else {
          // Navigate to Page 2 of general claims Form
          const nextToken = response.token;
          const nextPage = `/claim-details/page2`;
          
          // console.log('Next token !!!!', nextPage)
          this.router.navigate([nextPage], {queryParams: {claim: this.claim, id: this.id, token: nextToken}});
        }
        
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'This will cancel the claim application. Are you sure you want to proceed?',
      'Back',
      'CONTINUE'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }
}
